<div class="calendar-view">

  <!-- Table (scrolls internally) -->
  <div class="table-scroll-area">
    <table class="calendar-table">
      <thead>
        <tr>
          <th class="consultant-col">Consultant</th>
          <th *ngFor="let week of weekColumns" class="week-col">
            {{ week.label }}
          </th>
          <th class="total-col">Total</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of rows">
          <td class="consultant-col">{{ row.consultant }}</td>
          <td
            *ngFor="let hours of row.weekHours; let i = index"
            class="week-cell"
            [class.clash-cell]="row.weekHasClash[i]"
            [class.planned-cell]="!row.weekHasClash[i] && hours > 0"
          >
            {{ hours > 0 ? (hours | number:'1.2-2') : '' }}
          </td>
          <td class="total-col">{{ row.total | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Legend -->
  <div class="legend-row">
    <span class="legend-item">
      <span class="legend-swatch planned-swatch"></span>
      planned
    </span>
    <span class="legend-item">
      <span class="legend-swatch clash-swatch"></span>
      week contains a clash
    </span>
  </div>

</div>